import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import FontFaceObserver from 'fontfaceobserver';
import Amplify from 'aws-amplify';

import WrapRoot from './src/WrapRootElement';
import WrapPage from './src/WrapPageElement';

import 'url-search-params-polyfill';

// Imports styles directly to global css
import './src/styles/global.main.scss';

export const onClientEntry = () => {
  // Set up Sentry namespace on window if not in development
  if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
      dsn: 'https://3055b70e38c741e9ba585e0d9fa30fcb@o360347.ingest.sentry.io/5608696',
      environment: process.env.STAGE,
      release: process.env.RELEASE,
    });
    window.Sentry = Sentry;
  }

  // Register AWS Amplify/Cognito config (at the moment, not for prod)
  Amplify.configure({
    Auth: {
      oauth: {},
      region: process.env.AWS_REGION,
      userPoolId: process.env.AWS_USER_POOL_ID,
      userPoolWebClientId: process.env.AWS_USER_POOL_WEB_CLIENT_ID,
    },
  });

  // allows us to listen to fontLoad to avoid Flash of Invisible Text. akin to font-display: swap
  const font = new FontFaceObserver('proxima-nova');
  font
    .load()
    .then(() => {
      document.querySelector('body').classList.add('fontLoaded');
    })
    .catch((err) => {
      if (!window.Sentry) {
        return;
      }

      window.Sentry.addBreadcrumb({
        message: 'FontFaceObserver error',
        category: 'node_modules',
        data: err,
      });
      window.Sentry.captureException(err);
    });
};

export const replaceHydrateFunction = () => {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback);
  };
};

export const wrapPageElement = WrapPage;
export const wrapRootElement = WrapRoot;
